import { render, staticRenderFns } from "./parameter.vue?vue&type=template&id=7183b23e&scoped=true&"
import script from "./parameter.vue?vue&type=script&lang=js&"
export * from "./parameter.vue?vue&type=script&lang=js&"
import style0 from "./parameter.vue?vue&type=style&index=0&id=7183b23e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7183b23e",
  null
  
)

export default component.exports